var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { memo } from "react";
const SvgNp4 = _ref => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 42,
    viewBox: "0 0 35 42",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M22.102 32.309H3.936C1.96 32.309.41 30.96.41 28.986c0-1.33.664-2.437 1.55-3.766L21.013 3.066c1.329-1.55 2.215-2.437 4.43-2.437a3.49 3.49 0 0 1 3.526 3.526V26.55h3.12c1.551 0 2.88 1.31 2.88 2.861s-1.329 2.899-2.88 2.899h-3.12v5.963c0 1.79-1.55 3.342-3.526 3.342-1.79 0-3.341-1.551-3.341-3.342zm0-5.76v-15.97L8.828 26.55z",
    clipRule: "evenodd"
  })));
};
const Memo = /*#__PURE__*/memo(SvgNp4);
export default Memo;